import React from 'react';

const Debugger = ({ values }: { values: unknown }) => {
  return <pre>{JSON.stringify(values, undefined, 2)}</pre>;
};

export default Debugger;
